import { Button, Col, ModalV2, Row, Text } from 'components';
import { theme } from 'lib';

const SummaryRow = ({ label, children, emphasis }) => (
  <Row
    between
    center
    wid="100%"
    pad="10px 0"
    style={{ borderBottom: `1px solid ${theme.GREY_20}` }}
  >
    <Text b2 col={theme.GREY_60}>
      {label}
    </Text>

    {emphasis ? (
      <Text h4 bold>
        {children}
      </Text>
    ) : (
      <Text med>{children}</Text>
    )}
  </Row>
);

/**
 * The whole adjustment restated before it is committed.
 *
 * Built on ModalV2 rather than IrreversableModal because that one takes three strings and this is
 * seven labelled values, one of which — the resulting balance — has to stand out. ModalV2 also
 * brings the focus trap, Escape handling and focus restoration this dialog would otherwise need.
 */
const GloryBoardConfirmModal = ({
  visible,
  participant,
  teamName,
  currentPoints,
  actionLabel,
  points,
  reasonLabel,
  resultingBalance,
  onCancel,
  onConfirm,
  waiting,
  failure
}) => (
  <ModalV2
    visible={visible}
    closeModal={onCancel}
    width="520px"
    ariaLabel="Confirm point adjustment"
    header={<Text h3>Confirm Point Adjustment</Text>}
    footer={
      <Row between center wid="100%">
        <Button text="Cancel" onClick={onCancel} bordered style={{ width: 'fit-content' }} />
        <Button
          text={failure?.retryable ? 'Retry' : 'Confirm'}
          onClick={onConfirm}
          disabled={waiting || (failure && !failure.retryable)}
          style={{ width: 'fit-content' }}
        />
      </Row>
    }
  >
    <Col pad="8px 24px 24px">
      <SummaryRow label="Participant">{participant?.name}</SummaryRow>
      <SummaryRow label="Team">{teamName}</SummaryRow>
      <SummaryRow label="Current Points">{currentPoints.toLocaleString()}</SummaryRow>
      <SummaryRow label="Action">{actionLabel}</SummaryRow>
      <SummaryRow label="Points">{String(points)}</SummaryRow>
      <SummaryRow label="Reason">{reasonLabel}</SummaryRow>
      <SummaryRow label="New Balance" emphasis>
        {resultingBalance.toLocaleString()}
      </SummaryRow>

      {failure ? (
        <Col noFlex marg="20px 0 0">
          <Text med col={theme.RED}>
            {failure.message}
          </Text>
          <Text c1 col={theme.GREY_60} marg="4px 0 0">
            {failure.retryable
              ? // The retry carries the same identifier, so it cannot subtract twice even if the
                // first attempt reached the server and only the reply was lost.
                'No points were changed. Retrying is safe.'
              : 'No points were changed.'}
          </Text>
        </Col>
      ) : (
        <Text marg="20px 0 0">Are you sure you want to continue?</Text>
      )}
    </Col>
  </ModalV2>
);

export default GloryBoardConfirmModal;
